"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Analytics = (function () {
    function Analytics(options) {
        if (Analytics.instance) {
            throw new Error("Instantiation failed: Use Analytics.getInstance() instead of new.");
        }
        Analytics.instance = this;
        var self = this;
        this.setOptions(options);
        options = this.getOptions();
        function trackAnchor() {
            var href = this.getAttribute('href');
            if (typeof (href) !== 'undefined' && href !== null) {
                var category = self.determineLinkEventCategory(href);
                var nonInteract = category === 'Outbound Link' ? true : false;
                if (typeof (category) !== 'undefined' && category !== null) {
                    self.trackEvent(category, "Click", href, undefined, nonInteract);
                }
            }
        }
        var anchors = document.getElementsByTagName('a');
        for (var i = 0; i < anchors.length; i++) {
            this.addEventListener(anchors[i], 'click', trackAnchor);
        }
        this.addEventListener(document.documentElement, 'submit', function (e) {
            var target = e.target || e.srcElement;
            if (!(target instanceof Element) || target.tagName === undefined || target.tagName.toUpperCase() !== 'FORM') {
                return;
            }
            var element = target;
            var action = element.getAttribute('action');
            if (action === null || action === '' || action.indexOf('http') === -1 || action.indexOf('//' + window.location.hostname) !== -1) {
                return;
            }
            self.trackEvent("Outbound Form Submissions", "Submit", element.getAttribute("action"));
        });
        if (typeof (options.viewedBottom) !== 'undefined' && options.viewedBottom.enable) {
            var hasHitBottom_1 = false;
            var contentArea_1;
            if (typeof (options.contentArea) === 'string') {
                contentArea_1 = document.querySelector(options.contentArea);
            }
            else {
                contentArea_1 = options.contentArea;
            }
            var scrollingHitsBottomTest_1 = function () {
                if (!hasHitBottom_1 && self.isInView(contentArea_1)) {
                    self.removeEventListener(window, 'scroll', scrollingHitsBottomTest_1);
                    hasHitBottom_1 = true;
                    self.trackEvent('Viewed', 'Window Scroll: Viewed Bottom', window.location.href, undefined, options.viewedBottom.noninteraction);
                }
            };
            this.addEventListener(window, 'scroll', scrollingHitsBottomTest_1);
            scrollingHitsBottomTest_1();
        }
    }
    Analytics.getInstance = function (options) {
        if (Analytics.instance === undefined) {
            new Analytics(options);
        }
        else if (options !== undefined) {
            throw new Error('Instantiation failed: Cannot reconfigure Analytics. An instance was already created. To obtain a reference call getInstance() with no arguments.');
        }
        return Analytics.instance;
    };
    Analytics.prototype.trackPage = function (pageURL, fieldsObject) {
        if (pageURL.length > 0 && pageURL.substring(0, 1) !== '/') {
            pageURL = '/' + pageURL;
        }
        if (this.isClassicPageTrackerLoaded()) {
            _gaq.push(["_trackPageview", pageURL]);
        }
        else if (this.isUniversalPageTrackerLoaded()) {
            ga('send', 'pageview', pageURL, fieldsObject);
        }
        else {
            console.log("Google Analytics not loaded. Trying to track page: ", pageURL, fieldsObject);
        }
    };
    Analytics.prototype.trackEvent = function (category, action, opt_label, opt_value, opt_noninteraction) {
        if (typeof (opt_label) !== 'undefined' && opt_label !== null) {
            opt_label = opt_label.toString();
        }
        if (typeof (opt_value) !== 'undefined' && typeof (opt_value) !== 'number') {
            console.error("Value provided for opt_value needs to be a number. opt_value: ", opt_value);
        }
        if (this.isClassicPageTrackerLoaded()) {
            _gaq.push(["_trackEvent", category, action, opt_label, opt_value, opt_noninteraction]);
        }
        else if (this.isUniversalPageTrackerLoaded()) {
            ga('send', 'event', category, action, opt_label, opt_value, { 'nonInteraction': opt_noninteraction });
        }
        else {
            console.log("Google Analytics not loaded. Trying to tracked parameters: ", {
                category: category,
                action: action,
                opt_label: opt_label,
                opt_value: opt_value,
                opt_noninteraction: opt_noninteraction
            });
        }
    };
    Analytics.prototype.setOptions = function (options) {
        this.options = options = options || {};
        if (typeof (options.contentArea) === 'undefined') {
            options.contentArea = 'body';
        }
        if (typeof (options.viewedBottom) !== 'undefined') {
            if (typeof (options.viewedBottom.enable) === 'undefined') {
                options.viewedBottom.enable = false;
            }
            if (typeof (options.viewedBottom.noninteraction) === 'undefined') {
                options.viewedBottom.noninteraction = true;
            }
        }
        if (typeof (options.hostnames) === 'undefined') {
            options.hostnames = new Array();
        }
        this.options.hostnames.push(window.location.hostname);
        if (window.location.hostname.toLowerCase().indexOf('www.') === 0) {
            this.options.hostnames.push(window.location.hostname.substring(4));
        }
        else {
            this.options.hostnames.push('www.' + window.location.hostname);
        }
    };
    Analytics.prototype.getOptions = function () {
        return this.options;
    };
    Analytics.prototype.determineLinkEventCategory = function (href) {
        var category = null;
        var options = this.getOptions();
        if (typeof (href) !== 'undefined' && href !== null) {
            href = href.toLowerCase();
            var urlParts = href.match(/^((.*:)?\/\/([^\/:]+@)?([^\/:]+)(:[^\/]+)?)?([^\?]*)(\?.+)??$/);
            var isOutbound = void 0;
            var hrefhostname = void 0;
            var hrefPath = void 0;
            if (typeof (urlParts) !== 'undefined' && urlParts !== null) {
                hrefhostname = urlParts[4];
                hrefPath = urlParts[6];
                if (typeof (hrefPath) === 'undefined') {
                    hrefPath = '';
                }
                if (typeof (hrefhostname) === 'undefined') {
                    hrefhostname = '';
                }
                if (hrefhostname === '' || this.inArray(hrefhostname, options.hostnames)) {
                    isOutbound = false;
                }
                else {
                    isOutbound = true;
                }
            }
            else {
                isOutbound = false;
                hrefPath = href;
            }
            if (isOutbound) {
                category = "Outbound Link";
                console.log('outbound');
            }
            else if (href.indexOf("mailto:") === 0) {
                category = "Email Link";
                console.log('email');
            }
            else if (href.indexOf("tel:") === 0) {
                category = "Telephone Link";
                console.log('phone');
            }
            else if (hrefPath.length > 0 && hrefPath.charAt(href.length - 1) !== '/') {
                var extIndexOf = hrefPath.lastIndexOf('.');
                if (extIndexOf !== -1) {
                    var ext = hrefPath.substring(extIndexOf + 1);
                    if (ext !== "html" && ext !== "htm" && !(new RegExp('#')).test(ext)) {
                        category = "Download Link";
                    }
                }
            }
        }
        return category;
    };
    Analytics.prototype.addEventListener = function (element, name, handler) {
        if (element.addEventListener)
            element.addEventListener(name, handler);
        else if (element.attachEvent)
            element.attachEvent('on' + name, handler);
    };
    Analytics.prototype.removeEventListener = function (element, name, handler) {
        if (element.removeEventListener)
            element.removeEventListener(name, handler);
        else if (element.detachEvent)
            element.detachEvent('on' + name, handler);
    };
    Analytics.prototype.inArray = function (item, list) {
        for (var i = 0; i < list.length; i++) {
            if (list[i] === item)
                return true;
        }
        return false;
    };
    Analytics.prototype.isClassicPageTrackerLoaded = function () {
        return typeof (_gaq) !== 'undefined' && _gaq !== null;
    };
    Analytics.prototype.isUniversalPageTrackerLoaded = function () {
        return typeof (ga) !== 'undefined' && ga !== null;
    };
    Analytics.prototype.isInView = function (elem) {
        var bottom = elem.getBoundingClientRect().bottom;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        return (bottom > 0 && bottom < viewportHeight);
    };
    return Analytics;
}());
exports.Analytics = Analytics;
;
